export const WhatsAppContactConsultor =
  "https://api.whatsapp.com/send?phone=552197207-8113&text=Quero%20falar%20com%20um%20consultor%20Strm";
